<template>
  <div class="d-flex flex-column justify-space-between">
    <QuestionLabel data-test="label" :label="inputLabel" :hint="inputHint"/>

    <div>
      <DateField data-test="field"
                 :input="value"
                 :inputName="inputName"
                 outlined dense
                 :hideDetails="false"
                 :centered="false"
                 @setInput="$emit('setInput', $event)"
                 :validatorRule="rule.vValidateRule(project)"
                 :validatorTrigger="validatorTrigger"
                 :min="rule.minimum(project)"
                 :max="rule.maximum(project)"/>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ProjectFieldsMixin from '@/components/Mixins/ProjectFieldsMixin.vue';
import DateField from '@/components/Fields/DateField.vue';
import QuestionLabel from '@/components/Questions/QuestionLabel.vue';
import { DateRule } from '@/classes/rules/DateRule';
import { ProjectMeta } from '@/classes/ProjectMeta';

@Component({
  components: {
    QuestionLabel,
    DateField
  }
})
export default class ProjectDateField extends Mixins(ProjectFieldsMixin) {
  @Prop({ required: true, type: DateRule })
  public readonly rule!: DateRule<ProjectMeta>;

  @Prop({ required: true, type: ProjectMeta })
  public readonly project!: ProjectMeta;
}
</script>
